import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    showProject: false
}
const Slice = createSlice({
    name: 'ShowProject',
    initialState: initialState,
    reducers: {
        setShowProjectSlice(state, action: PayloadAction<boolean>) {
            state.showProject = action.payload;
        }
    }
})
export default Slice;